export default __webpack_public_path__ + "static/media/flask.4453efd7.png";